/**
 * FriendTempl Template
 * @category testApp
 */
class FriendTempl {
	/**
	 * Sub1 Templ
	 * @param  {Object} _d={}
	 */
	static getTempl(_d={}, _profileDomain='', _sandboxDomain='') {

		// console.log('FriendTempl.js > _d : ' , _d, _d.length);

		if(_d.error == 'Forbidden') {
			return FriendTempl.noData();
		} else if (_d.length == 0) {
			return FriendTempl.noData();
		} else {
			let list = [];
			list.push(_d.map( item =>{
				return FriendTempl.itemTempl(item, _profileDomain, _sandboxDomain);
			}).join(''));
			return `
				<ul class="friend-list">${list.join('')}</section>
			`;
		}
	}

	static getCounter(_d={}) {
		let counter = 0;
		_d.forEach(function(k, i) {
			if( _d[i].playing ) counter++;
		});
		return counter;
	}

	static itemTempl(_d, _profileDomain, _sandboxDomain){
		return `
    	<li class="friend-item">
    		<a class="link" href="#" style="cursor: default;">
    			<img class="thumb" src="${_profileDomain}/account_profile_images/${_d.userId}?imageSize=small">
    			<span class="info">
					<span class="character">${_d.nickName}</span>
					${ (_d.playing && _d.loginCharacter && _d.loginCharacter.geoZoneName) ? `<span class="location">${_d.loginCharacter.geoZoneName}</span>`: ``}
					${_d.playing ? `<i class="is-online"></i>` : ``}
				</span>
    		</a>
    	</li>`;
	}

	static noData() {
		return `
			<div class="nodata"><p>대협! 등록된 의형제가 없으시네요.<br>게시판에서 강호인들을 만나 친분을 나눠보세요.</p><a class="link" href="/board/server/list">서버 게시판 보기</a></div>
		`;
	}
	static NoBossChar() {
		return `
			<div class="nodata"><p>대협! 어떤 막내의 정보를 알고 싶나요?<br>함께 모험을 떠날 막내를 대표 캐릭터로 설정해주세요.</p><a class="link" href="#">대표 캐릭터 설정하기</a></div>
		`;
	}



} // end of class

export default FriendTempl;